import XLSX from 'xlsx';
// 获取本地excel文件 第一列数据
function getFirstColumn(file, string, callback) {
  const firstColumn = [];
  const fileReader = new FileReader();
  fileReader.readAsBinaryString(file);
  const uploadPromise = () => {
    return new Promise((resolve, reject) => {
      fileReader.onload = function(ev) {
        var data = ev.target.result;
        var workbook = XLSX.read(data, {
          type: 'binary'
        });
        var worksheetName = workbook.SheetNames[0];
        var worksheet = workbook.Sheets[worksheetName];
        // var fromTo = worksheet['!ref'];
        for (var item in worksheet) {
          if (item.substr(0, 1) === string && item.length > 2) {
            firstColumn.push(worksheet[item].v);
          } else if (item.substr(0, 1) === string && item.substr(1, 1) !== '1') {
            firstColumn.push(worksheet[item].v);
          }
        }
        resolve(firstColumn);
      };
    });
  };
  uploadPromise().then((data) => {
    if (callback) callback(data);
  });
}
export default { getFirstColumn };
